// extracted by mini-css-extract-plugin
export default {"card":"CLZM_","header":"Xe0l3","inner":"dBQkd","tooltip":"TMynz","tooltipText":"RraJh"};